import { useState, type ReactNode } from "react";

interface Props {
  src?: string;
  alt?: string;
  className?: string;
  /** Rendered when there's no src or the image fails to load. */
  fallback: ReactNode;
  eager?: boolean;
}

/** <img> that fades in smoothly on load and gracefully swaps to a fallback
 *  (emoji/gradient) on error — so a broken URL never shows a broken-image icon. */
export function SmartImage({ src, alt = "", className, fallback, eager }: Props) {
  const [failed, setFailed] = useState(false);
  const [loaded, setLoaded] = useState(false);
  if (!src || failed) return <>{fallback}</>;
  return (
    <img
      src={src}
      alt={alt}
      loading={eager ? "eager" : "lazy"}
      decoding="async"
      className={`${className ?? ""} transition-opacity duration-500 ease-out ${
        loaded ? "opacity-100" : "opacity-0"
      }`}
      onLoad={() => setLoaded(true)}
      onError={() => setFailed(true)}
    />
  );
}
